import * as React from 'react'
import { PickingListCalculationRowShape, StagedPick } from '../../api/api_data_types'
import pickingListRemainingQuantity from './pickingListRemainingQuantity'

interface PickingListCopyQuantityButtonProps {
  row: PickingListCalculationRowShape
  changedQuantities: Record<string, StagedPick>
  setChangedQuantities: React.Dispatch<React.SetStateAction<Record<string, StagedPick>>>
}

export default function PickingListCopyQuantityButton({
  setChangedQuantities,
  row,
}: PickingListCopyQuantityButtonProps) {
  const itemId = row.item?.id
  const key = row.key
  if (row.submitted || itemId == null) return null

  const copyQuantity = () => {
    const remainingQuantity = pickingListRemainingQuantity(row)

    if (remainingQuantity > 0) {
      setChangedQuantities((current) => ({
        ...current,
        [key]: { item_no: row.item_no, quantity: remainingQuantity, item_id: itemId },
      }))
    } else {
      setChangedQuantities((current) => {
        const next = { ...current }
        delete next[key]
        return next
      })
    }
  }

  return <i className="fa fa-icon fa-arrow-left cursor-pointer" onClick={copyQuantity} title="Kopier resterende antal" />
}
